module.exports = __webpack_public_path__ + "static/media/optin-monster.8b9d7cd5.svg";